import { ReactNode } from 'react';

import {
   ExternalDocumentationStorageLimitExceededFault,
   PatientConsentDocumentApproveAttachmentsCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor, dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { ExternalDocumentationStorageLimitExceededTranslation } from '../../../../common/ExternalDocumentationStorageLimitExceededTranslation';

type PatientConsentDocumentApproveAttachmentsActionEventInterceptorProps = {
   readonly children: ReactNode;
   readonly consentDocumentId: number;
};

export const PatientConsentDocumentApproveAttachmentsActionEventInterceptor = (
   props: PatientConsentDocumentApproveAttachmentsActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: approvePatientConsentDocument } = useCqrsCommand<
      void,
      void,
      ExternalDocumentationStorageLimitExceededFault
   >(
      () => {
         const command = new PatientConsentDocumentApproveAttachmentsCommand();
         command.consentDocumentId = props.consentDocumentId;
         return command;
      },
      {
         onFault: {
            'egabinet-patient-frontend-api:ExternalDocumentationStorageLimitExceededFault': () =>
               dispatchSnackbarNegativeEvent(<ExternalDocumentationStorageLimitExceededTranslation />),
         },
      }
   );

   return <ActionEventInterceptor action={approvePatientConsentDocument}>{props.children}</ActionEventInterceptor>;
};
